export default __webpack_public_path__ + "e7d8ae4702bc5228893caf7c2cf458f2.svg";